<template>
    <div>
        <div>
            <ul class="list-group mb-2">
                <template v-for="document in acceptanceDocuments">

                    <!-- Documents -->
                    <li v-if="!document.is_revoked || showingRevoked"
                        :class="{'revoked' : document.is_revoked}"
                        class="list-group-item d-flex align-items-center">

                        <div>

                            <!-- Title -->
                            <div class="text-info" v-if="onRendering &&  (onRendering.id == document.id) && !document.is_locked">We are working on your Files</div>
                            <div class="text-info" v-else>
                                <span v-if="document.is_revoked" class="text-danger">Revoked Document</span>
                                <span v-else>Your Files</span>
                            </div>

                            <!-- Dates -->
                            <div class="text-sm text-muted">
                                <div v-text="shortDateTime(document.created_at)"></div>
                                <div v-if="document.is_revoked">
                                    <b>Revoked: </b><span v-text="shortDateTime(document.unlocked_at)"></span>
                                </div>
                            </div>
                        </div>

                        <div  class="ml-auto">

                            <!-- Download when Document is Ok -->
                            <a v-if="document.is_locked" :href="`/projects/${project.slug}/acceptance-documents/${document.version}`" class="btn btn-sm btn-success">Download</a>

                            <!-- Showing document status on rendering or revoked -->
                            <div v-else class="badge" :class="{'badge-danger': document.is_revoked, 'badge-info': !document.is_revoked}">
                                <i class="fa fa-spinner fa-spin mr-2" v-if="!document.is_locked && !document.is_revoked"></i>
                                <span v-text="document.status"></span>
                            </div>
                        </div>

                    </li>
                </template>
            </ul>

            <!-- Show revoked documents link? -->
            <div class="d-flex" v-if="!showingRevoked && authorize('admin') && revokedDocuments.length">
                <a class="btn-link text-sm text-danger ml-auto" href="#" role="button" @click="showingRevoked = true">
                    Show Revoked Documents
                </a>
            </div>
        </div>

        <!-- On Demand Rendering Old Project Documents -->
        <div v-if="!isLoading && acceptanceDocuments.length == 0 && project.is_completed">
            <ul class="list-group mb-2">
                    <li class="list-group-item d-flex align-items-center">
                        <div>
                            <div class="text-info">Click "Render" to generate your Files</div>
                            <div class="d-flex text-sm text-muted">
                                <div>Project Close: </div>
                                <div class="ml-1" v-text="shortDateTime(project.completed_at)"></div>
                            </div>
                        </div>
                        <div class="ml-auto">
                            <button @click.prevent="renderDocument()" :disabled="isRendering" class="btn btn-sm btn-info">
                                Render
                            </button>
                        </div>
                    </li>
            </ul>
        </div>
        <div v-if="isLoading">
            <i class="fa fa-spinner fa-spin"></i> Loading
        </div>
    </div>
</template>
<style type="text/css">
.revoked{
    background: #ffecec;
    opacity: .85;
}
</style>
<script>
export default {

    props: {
        project:{
            type: Object,
            required: true,
        }
    },

    data() {
        return {
            isLoading : true,
            isRendering: false,
            onRendering: null,
            showingRevoked: false,
            acceptanceDocuments: []
        }
    },

    created(){
        this.fetchData();
    },

    methods: {

        fetchData() {
            App.request().get(`/projects/${this.project.slug}/acceptance-documents/all`)
                .then(response => {
                    this.isLoading = false;
                    this.acceptanceDocuments = response.data.documents
                    this.initalizeEchoListener()
                })
                .catch(errors => {
                    console.log(errors)
                })
        },

        initalizeEchoListener() {
            this.onRendering = _.find(this.acceptanceDocuments, document => (!document.is_ready && !document.is_revoked));
            if (this.onRendering) {
                window.Echo.channel(`acceptance-document-rendering-${this.onRendering.id}`).listen('\\App\\Events\\RenderingStatusChanged', event => {
                    if (this.onRendering.status != 'Ready') {
                        this.onRendering.status = event.document.status
                        this.onRendering.is_locked = event.document.is_locked
                        this.onRendering.is_ready = event.document.is_ready
                    }
                });
            }
        },

        renderDocument() {
            this.isRendering = true
            axios.get(`/projects/${this.project.slug}/acceptance-documents/render`)
                .then(() => {
                    this.refreshPage()
                })
                .catch(() => {
                    this.isRendering = false
                })
        }
    },

    computed:{
        revokedDocuments(){
            return _.filter(this.acceptanceDocuments, document => document.is_revoked)
        }
    }
}
</script>
